import React from 'react';
import styles from './findus.module.scss';
import Image from '@/src/shared/components/Image';
import { APP_CONFIGS } from '@/src/core/constants/app';
import clsx from 'clsx';

const items = {
  vancouver: {
    key: 1,
    icon: 'vancouver.webp',
    text: APP_CONFIGS.companyAddress.canada,
  },
  sanFrancisco: {
    key: 2,
    icon: 'america.webp',
    text: (
      <>
        2 Embarcadero Center, 8th Floor, <strong>San Francisco, CA </strong>{' '}
        94111 USA
      </>
    ),
  },
  phone: {
    key: 3,
    icon: 'phone.webp',
    text: <a href="tel:+12367075116">+1 (236) 707-5116</a>,
  },
};

const FindUs = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <h2 className={styles.title}>Find Us On:</h2>
        <div className={styles.findUsWrapper}>
          {Object.values(items).map((itemInfo) => {
            return (
              <div key={itemInfo.key} className={styles.rowItem}>
                <div className={styles.imageWrapper}>
                  <Image
                    loading="lazy"
                    draggable={false}
                    fill
                    src={'/images/landing/about-us/' + itemInfo.icon}
                    alt="about us"
                  />
                </div>
                <p
                  className={clsx(
                    styles.location,
                    itemInfo.key === 3 && styles.phone
                  )}
                >
                  {itemInfo.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FindUs;
